import PubSub from "underpub-js";

var HeroPost = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-HeroPost',
	};

	$.extend(true, this.options, options);

};

HeroPost.prototype.init = function() {

	var self = this;

};

export default HeroPost;
